export { Scale as default } from './Scale';
